import { render, staticRenderFns } from "./ConnectionNew.vue?vue&type=template&id=c97143f2"
import script from "./ConnectionNew.vue?vue&type=script&lang=js"
export * from "./ConnectionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports